fragment MaterializedMessageBody on MaterializedEmailTemplate {
    body
    emailTemplate {
        id
        name
    }
    entity {
        id
    }
}
